import { createSlice } from '@reduxjs/toolkit';
import { RouteConstants } from '../constants/RouteConstants';

export const bucketSlice = createSlice({
  name: 'bucketData',
  initialState: {
    bucketInfo: JSON.parse(sessionStorage.getItem('bucketInfo') || '{}') as any,
    folderInfo: JSON.parse(sessionStorage.getItem('folderInfo') || '{}') as any,
    originPath: RouteConstants.ROUTE_AMS_FILES,
    fileHistoryPath: ''
  },
  reducers: {
    setBucketData: (state, action) => {
      sessionStorage.setItem('bucketInfo', JSON.stringify(action.payload));
      state.bucketInfo = action.payload;
    },
    setFolderData: (state, action) => {
      sessionStorage.setItem('folderInfo', JSON.stringify(action.payload));
      state.folderInfo = action.payload;
    },
    setBucketOriginPath: (state, action) => {
      state.originPath = action.payload;
    },
    setFileHistoryPath: (state, action) => {
      state.fileHistoryPath = action.payload;
    }
  }
});

export const { setBucketData, setFolderData, setBucketOriginPath, setFileHistoryPath } =
  bucketSlice.actions;

export default bucketSlice.reducer;
